<template>
  <div>
    <div class="text-center">
      <v-menu offset-y v-model="showDialog" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              style="width: 48px; height: 36px"
              v-bind="attrs"
              v-on="on"
              @click="showDialog = !showDialog"
          >
            <i class="bx bx-columns font-size-20"></i>
          </v-btn>
        </template>
        <div>
          <v-list class="row mb-3 pa-3">
            <v-list-item-title style="text-align: center;"><h3>Kolon Görünüm Ayarı</h3></v-list-item-title>
            <v-list-item
                class="col-md-2 col-lg-3 col-6"
                style="height: 5px;"
                v-for="i in colsTemp" :key="i.key"
            >
              <v-checkbox v-model="i.visible" :key="i.key">
                <template v-slot:label>
                  <span style="margin: auto; padding-top: 5px;">{{i.label}}</span>
                </template>
              </v-checkbox>
            </v-list-item>
            <v-spacer></v-spacer>
            <v-btn class="col-6" plain color="red darken-2" @click="closeDialog()">Kapat</v-btn>
            <v-btn class="col-6" plain color="success darken-2" @click="saveColData">Kaydet</v-btn>
          </v-list>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>

import {showProcessErrorMessage, showProcessPromptMessage} from "@/state/alertHelpers";

export default {
  name: "TableColumnSelect",
  props: {
    cols: {
      type: Array,
      default: () => []
    }
  },
  mounted() {

  },
  data() {
    return {
      showDialog: false,
      dialog: false,
      colsTemp: []
    }
  },
  methods: {
    closeDialog() {
      showProcessPromptMessage({
        title: 'Kaydetmeden çıkmak istediğinize emin misiniz ?',
        text: 'Kaydedilmeyen değişiklikler tabloya yansımayacaktır'
      }).then((confirm) => {
        if (confirm.isConfirmed)
          this.showDialog = false;
      });
    },
    saveColData() {
      if (this.colsTemp.filter((e) => e.visible === true) < 1) {
        showProcessErrorMessage({
          title: 'İşlem Başarısız',
          text: 'Lütfen En Az Bir Adet Filtre Seçiniz',
        });
      } else {
        this.$emit("saveColData", this.colsTemp);
        this.showDialog = false;
      }
    }
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
    },
    "showDialog": function (newVal) {
      if (newVal)
        for (let i = 0; i < this.cols.length; i++) {
          this.colsTemp[i] = Object.assign({}, this.cols[i]);
        }
      else
        this.colsTemp = [];
      this.dialog = newVal
    },
    "colsTemp": function (newVal) {
      newVal
    }
  }
}
</script>

<style scoped>

</style>